import { atom } from "jotai";
import type { IMapRequest } from "types/maps/request";

/**
 * Facility Map Request Atom
 *
 * Stores the current map request configuration for facilities.
 * This atom can be used to track and manage facility map requests
 * independently of Redux state.
 */

/**
 * Initial/empty facility map request
 */
export const EMPTY_FACILITY_MAP_REQUEST: Maybe<IMapRequest> = null;

/**
 * Base atom for facility map request
 * Stores the current IMapRequest for facilities
 */
export const facilityMapRequestAtom = atom<Maybe<IMapRequest>>(
  EMPTY_FACILITY_MAP_REQUEST
);
